import React from 'react'
import './Footer.css'

const Footer = () => {
  return (
    <div className='row footer-style p-5 mt-5' style={{color: "white"}}>
        <div className="col-6 d-flex justify-content-center">
            <p>
              <b>- CHI SIAMO?</b> <br/>
              Siamo studenti della 4C ITIS info A.S 2022/2023
            </p>
        </div>

        <div className="col-6 d-flex justify-content-center">
            <p>
              <b>- COME NASCE IL PROGETTO?</b> <br/>
              Il progetto nasce con l'intento di creare un'area dove si possano visualizzare tutti i nostri porgetti scolastici
            </p>
        </div>
    </div>
  )
}

export default Footer